import { useState, useEffect } from "react";

// Breakpoints should match your CSS breakpoints
const BREAKPOINTS = {
  desktop: 992,
  tablet: 768,
};

export function useDevice() {
  // compute initial sizes (safe for SSR)
  const getInitialSizes = () => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    ) {
      return { isDesktop: false, isTablet: false, isMobile: true };
    }
    const isDesktop = window.matchMedia(
      `(min-width: ${BREAKPOINTS.desktop}px)`
    ).matches;
    const isTablet =
      !isDesktop &&
      window.matchMedia(`(min-width: ${BREAKPOINTS.tablet}px)`).matches;
    const isMobile = !isDesktop && !isTablet;
    return { isDesktop, isTablet, isMobile };
  };

  const [sizes, setSizes] = useState(getInitialSizes);

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    )
      return undefined;

    const mqDesktop = window.matchMedia(
      `(min-width: ${BREAKPOINTS.desktop}px)`
    );
    const mqTablet = window.matchMedia(`(min-width: ${BREAKPOINTS.tablet}px)`);

    const handler = () => {
      const isDesktop = mqDesktop.matches;
      const isTablet = !isDesktop && mqTablet.matches;
      const isMobile = !isDesktop && !isTablet;
      setSizes({ isDesktop, isTablet, isMobile });
    };

    // attach listeners
    if (mqDesktop.addEventListener)
      mqDesktop.addEventListener("change", handler);
    else mqDesktop.addListener(handler);

    if (mqTablet.addEventListener) mqTablet.addEventListener("change", handler);
    else mqTablet.addListener(handler);

    window.addEventListener("resize", handler);

    // call once to ensure correct initial value
    handler();

    return () => {
      if (mqDesktop.removeEventListener)
        mqDesktop.removeEventListener("change", handler);
      else mqDesktop.removeListener(handler);

      if (mqTablet.removeEventListener)
        mqTablet.removeEventListener("change", handler);
      else mqTablet.removeListener(handler);

      window.removeEventListener("resize", handler);
    };
  }, []);

  return sizes;
}

export default useDevice;
